import Skeleton from "react-loading-skeleton";
import React from "react";

export const CardSkeleton = () => (
  <div className="card">
    <Skeleton height={150} />
    <div className="card-content">
      <div className="row">
        <div className="col-sm-4 col-md-4 col-4"></div>
        <div className="col-sm-1 col-md-1 col-1">
          <Skeleton height={15} width={150} />
        </div>
        <div className="col-sm-1 col-md-1 col-1 ml-2">
          <Skeleton height={15} width={150} />
        </div>
        <div className="col-sm-4 col-md-4 col-4"></div>
      </div>
    </div>
  </div>
);

export const DataGridSkeletonPageSimpleWithTitle = () => (
  <div className="card shadow-sm rounded-vlg p-3">
    <div className="row">
      <div className="col-sm-2 col-md-2 col-3 mb-2 p-0">
        <Skeleton height={30} />
      </div>
      <div className="col-sm-7 col-md-7 col-3"></div>
      <div className="col-sm-1 col-md-1 col-1 mb-2">
        <Skeleton height={30} />
      </div>
      <div className="col-sm-2 col-md-2 col-8 p-0 mb-2">
        <Skeleton height={30} />
      </div>
    </div>
    <div className="row  mb-2">
      <div className="col-sm-12 col-md-12 col-12 p-0">
        <Skeleton height={20} />
        <Skeleton height={2} />
        <Skeleton count={5} />
      </div>
    </div>
    <div className="row">
      <div className="col-sm-3 col-md-1 col-3 p-0">
        <Skeleton height={30} />
      </div>
      <div className="col-sm-6 col-md-10 col-6"></div>
      <div className="col-sm-3 col-md-1 col-3 p-0">
        <Skeleton height={30} />
      </div>
    </div>
  </div>
);

export function DataGridSkeletonPageSimple() {
  return (
    <>
      <div className="card shadow-sm rounded-vlg p-3">
        <div className="row">
          <div className="col-sm-2 col-md-2 col-3 mb-2 p-0"></div>
          <div className="col-sm-7 col-md-7 col-3"></div>
          <div className="col-sm-1 col-md-1 col-1 mb-2">
            <Skeleton height={30} />
          </div>
          <div className="col-sm-2 col-md-2 col-8 p-0 mb-2">
            <Skeleton height={30} />
          </div>
        </div>
        <div className="row  mb-2">
          <div className="col-sm-12 col-md-12 col-12 p-0">
            <Skeleton height={20} />
            <Skeleton height={2} />
            <Skeleton count={5} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3 col-md-1 col-3 p-0">
            <Skeleton height={30} />
          </div>
          <div className="col-sm-6 col-md-10 col-6"></div>
          <div className="col-sm-3 col-md-1 col-3 p-0">
            <Skeleton height={30} />
          </div>
        </div>
      </div>
    </>
  );
}
export function DataGridSkeletonPageActionFilter() {
  return (
    <>
      <div className="card shadow-sm rounded-vlg p-3">
        <div className="row">
          <div className="col-sm-2 col-md-2 col-3 mb-2 p-0">
            <Skeleton height={30} />
          </div>
          <div className="col-sm-7 col-md-7 col-3"></div>
          <div className="col-sm-1 col-md-1 col-1 mb-2">
            <Skeleton height={30} />
          </div>
          <div className="col-sm-2 col-md-2 col-8 p-0 mb-2">
            <Skeleton height={30} />
          </div>
        </div>
        <div className="row  mb-2">
          <div className="col-sm-12 col-md-12 col-12 p-0">
            <Skeleton height={20} />
            <Skeleton height={2} />
            <Skeleton count={5} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3 col-md-1 col-3 p-0">
            <Skeleton height={30} />
          </div>
          <div className="col-sm-6 col-md-10 col-6"></div>
          <div className="col-sm-3 col-md-1 col-3 p-0">
            <Skeleton height={30} />
          </div>
        </div>
      </div>
    </>
  );
}
